export default __webpack_public_path__ + "static/about3-1eee879b25acb1ca032f576569b1211a.webp";